import '../App.css';
import MintWidget from '../components/MintWidget';
import NftCard from '../components/NftCard';
import { InjectedConnector } from '@web3-react/injected-connector';
import { useWeb3React } from '@web3-react/core';
import axios from 'axios';
import { useState } from 'react';

var Mint = (props) => {
  const entanglerAddress = '0xDC08aa5d94AC05F73DdB1F29a13C1b6e9c384980';
  const { account, activate, active } = useWeb3React();
  const injected = new InjectedConnector();

  let [preexistingNftCardsState, setPreexistingNftCardsState] = useState([]);
  let preexistingNfts = [];
  let preexistingNftCards = [];

  let nftCards = [];
  let orderedIndices = [];
  let allNftsFinished = true;

  for (let i = 0; i < props.userNfts.length; i++) {
    let lowest = parseInt(props.userNfts[i][0].id), lowestIdx = i;
    for (let j = 0; j < props.userNfts.length; j++) {
      if ((parseInt(props.userNfts[j][0].id) < lowest && !orderedIndices.includes(j)) ||
          (orderedIndices.includes(lowestIdx) && !orderedIndices.includes(j))) {
        lowest = parseInt(props.userNfts[j][0].id); lowestIdx = j;
      }
    }
    if (props.userNfts[i][0].img === null || props.userNfts[i][0].TVR === null) allNftsFinished = false;
    if (props.userNfts[i][0].royalties.some(r => typeof r === 'undefined')) allNftsFinished = false;
    orderedIndices.push(lowestIdx);
  }

  for (let i = 0; i < orderedIndices.length; i++) {
    const nft = props.userNfts[orderedIndices[i]];
    nftCards.push(<NftCard key={nft[0].id} nft={nft[0]} />);
  }

  if (active && preexistingNftCardsState.length === 0) {
    props.preexistingNfts.length > 0
      ? setPreexistingNftCardsState(props.preexistingNfts)
      : getPreexistingNfts();
  }

  async function getPreexistingNfts(itr = 0) {
    axios.get(`https://eth-mainnet.g.alchemy.com/nft/v2/pWHRbgDqpCxDUCh7jqGn1UwwP3gwZyv5/getNFTs?owner=${account}`)
      .then(res => {
        res.data.ownedNfts.forEach(item => {
          if (item.contract.address.toLowerCase() === entanglerAddress.toLowerCase()) {
            const nft = { id: parseInt(item.id.tokenId, 16), royalties: [], mandates: [], TVR: 0, img: item.media[0].raw };
            item.metadata.attributes.forEach(attr => {
              if (attr.trait_type !== 'TVR') { nft.royalties.push(attr.value); nft.mandates.push([attr.trait_type]); }
              else { nft.TVR = attr.value; }
            });
            preexistingNfts.push(nft);
          }
        });
        preexistingNfts.forEach(n => preexistingNftCards.push(<NftCard key={n.id} nft={n} />));
        props.setPreexistingNfts(preexistingNftCards);
        setPreexistingNftCardsState(preexistingNftCards);
      })
      .catch(() => {
        if (itr < 50) setTimeout(() => getPreexistingNfts(itr + 1), 750 + Math.floor(Math.random() * 750));
      });
  }

  return (
    <>
      <div className="second-container pb-50">
        {active
          ? <p className="mint-page-heder">Select a quantity and mint your ImpactKeys below.</p>
          : <p className="connect-wallet-page-heder">Connect your wallet to get started.</p>
        }
        <MintWidget
          updateNfts={props.onNewNfts}
          waitingForUserToConfirm={props.waitingForUserToConfirm}
          waitingForTxToConfirm={props.waitingForTxToConfirm}
          waitingForRoyaltyGeneration={props.waitingForRoyaltyGeneration}
          missingRoyalties={props.missingRoyalties}
          setLatentNfts={props.setLatentNfts}
          onSetUserAccount={props.onSetUserAccount}
          onSetEntangler={props.onSetEntangler}
          onSetSigner={props.onSetSigner}
          onSetNftsToUpdate2={props.onSetNftsToUpdate2}
          onMintInProgress={props.onMintInProgress}
          onMissingRoyalties={props.onMissingRoyalties}
          onWaitingForUserToConfirm={props.onWaitingForUserToConfirm}
          onWaitingForTxToConfirm={props.onWaitingForTxToConfirm}
          onWaitingForRoyaltyGeneration={props.onWaitingForRoyaltyGeneration}
        />
        {props.mintInProgress && (
          <>
            <div className="loading">Minting...</div>
            {props.waitingForUserToConfirm && <div className="tx-processing-status">(waiting for transaction approval)</div>}
            {props.waitingForTxToConfirm && !props.waitingForUserToConfirm && <div className="tx-processing-status">(transaction processing)</div>}
            {props.waitingForRoyaltyGeneration && !props.waitingForTxToConfirm && !props.waitingForUserToConfirm && <div className="tx-processing-status">(generating token attributes)</div>}
          </>
        )}
        {props.userNfts.length > 0 && (
          <>
            <div>Your ImpactKeys</div>
            {!allNftsFinished && <div className="results-subtext">(please be patient &mdash; image rendering and TVR calculation can take several minutes. Do not refresh the page.)</div>}
            {nftCards}
          </>
        )}
        {preexistingNftCardsState.length > 0 && (
          <>
            <div className="m4">Your ImpactKeys</div>
            {preexistingNftCardsState}
          </>
        )}
      </div>
    </>
  );
};

export default Mint;
